// extracted by mini-css-extract-plugin
module.exports = {"container":"SummarySection_container__2YInv"};